import { Handshake, Clock, MessageSquare, ShieldCheck } from "lucide-react";

const COMMITMENTS = [
  {
    icon: Handshake,
    title: "Honest work, honest pricing",
    desc: "No bloated retainers, no hidden fees. You&apos;ll know exactly what you&apos;re paying for and what you&apos;re getting.",
  },
  {
    icon: Clock,
    title: "Fast, focused turnaround",
    desc: "I keep the scope tight on purpose. Concepts come back quickly so we can iterate and ship — not sit on revisions for weeks.",
  },
  {
    icon: MessageSquare,
    title: "You talk directly to me",
    desc: "No sales team, no junior handoffs. You message me, I reply. Every decision goes through the person actually building your site.",
  },
  {
    icon: ShieldCheck,
    title: "Built to actually convert",
    desc: "Every page is designed around one job: turning your visitors into calls, bookings and estimates. Pretty design is the side effect.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="how-i-work"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="text-xs tracking-[0.22em] uppercase text-blue-400 font-medium">
            How I work
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold mt-4 leading-[1.1]">
            What you can expect{" "}
            <span className="italic">working with me</span>.
          </h2>
          <p className="mt-5 text-white/55 max-w-2xl text-sm md:text-base">
            I&apos;m building this brand from scratch. Instead of fake reviews, here&apos;s
            exactly how I work — and what every client gets.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {COMMITMENTS.map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                key={c.title}
                data-testid={`commitment-card-${i + 1}`}
                className="group card-soft rounded-2xl p-7 md:p-8 flex gap-5"
              >
                <div className="shrink-0 h-12 w-12 rounded-xl flex items-center justify-center border border-white/10 bg-white/[0.03] text-blue-300 group-hover:border-blue-500/40 group-hover:bg-blue-500/10 transition-colors">
                  <Icon size={20} />
                </div>
                <div>
                  <h3 className="font-display text-xl md:text-2xl text-white">
                    {c.title}
                  </h3>
                  <p
                    className="mt-3 text-sm md:text-[15px] text-white/60 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: c.desc }}
                  />
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 rounded-2xl border border-white/10 bg-[#0F0F0F] p-7 md:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <div className="font-display text-xl md:text-2xl text-white">
              First client testimonials coming soon.
            </div>
            <p className="mt-2 text-sm text-white/55 max-w-xl">
              I&apos;d rather build a brand on real results than fake quotes. If you&apos;re one of my first clients, your story goes here.
            </p>
          </div>
          <span className="self-start md:self-auto text-[11px] tracking-[0.22em] uppercase text-blue-400 font-medium border border-blue-500/30 rounded-full px-3 py-1.5">
            Honest by default
          </span>
        </div>
      </div>
    </section>
  );
}
